module.exports = __webpack_public_path__ + "media/images/WFC_Award_White-08316153a9d85395e26778bfe4ba074d.png";